import type { JSX } from "react";
import { cn } from "./cn";
import { Icon, type IconName } from "./Icon";

export interface ActionButtonProps {
  readonly label: string;
  readonly variant?: "default" | "primary" | "danger";
  readonly icon?: string;
  readonly onClick?: () => void;
}

const variantStyles: Readonly<Record<NonNullable<ActionButtonProps["variant"]>, string>> = {
  default: "bg-surface-hover text-content",
  primary: "bg-green text-white",
  danger: "bg-red text-white",
};

/**
 * Action button used in meeting cards, email detail, etc.
 */
export function ActionButton({ label, variant = "default", icon, onClick }: ActionButtonProps): JSX.Element {
  return (
    <button
      className={cn("border-none rounded-[10px] px-4 py-2 text-sm cursor-pointer inline-flex items-center gap-1.5", variantStyles[variant])}
      type="button"
      onClick={onClick}
    >
      {icon && <Icon name={icon as IconName} size={14} />}
      {label}
    </button>
  );
}
